// Qué skills carga el agente y para qué pedido — ADR-2026-09-18-el-uso-de-las-skills-se-registra.
// Un evento de PostHog por `cargar_skill` (`agente_skill_cargada`), con lo justo para
// decidir después cómo partir las skills pesadas: cuál, de qué origen, si existía, en
// qué turno, con qué otras skills de la MISMA ronda y un recorte del pedido del usuario.
// Puro: el hook del chat arma las props con esto y las manda con `trackEvent`.

export const EVENTO_SKILL_CARGADA = 'agente_skill_cargada';
/** El pedido viaja recortado: alcanza para clasificar la tarea, no para leer el chat. */
export const TOPE_PEDIDO = 160;

export interface PropsDeSkillCargada {
  skill: string;
  encontrada: boolean;
  origen: 'fabrica' | 'empresa' | null;
  chat_id: string | null;
  company_id: string | null;
  /** Número de mensaje del usuario en el chat (1 = el primero). */
  turno: number;
  /** Las que ya se cargaron en esta misma ronda, antes de ésta. */
  junto_con: string[];
  pedido: string;
}

export function propsDeSkillCargada(a: {
  pedida: unknown;
  cargada: string | null;
  origen: 'fabrica' | 'empresa' | null;
  chatId: string | null;
  companyId: string | null;
  turno: number;
  yaCargadas: readonly string[];
  pedido: string;
}): PropsDeSkillCargada {
  const skill = a.cargada ?? (typeof a.pedida === 'string' ? a.pedida.trim().slice(0, 80) : '');
  return {
    skill,
    encontrada: a.cargada !== null,
    origen: a.cargada ? a.origen : null,
    chat_id: a.chatId,
    company_id: a.companyId,
    turno: a.turno,
    junto_con: a.yaCargadas.filter((s) => s !== skill),
    pedido: a.pedido.replace(/\s+/g, ' ').trim().slice(0, TOPE_PEDIDO),
  };
}
